module.exports = __webpack_public_path__ + "media/images/landings/promotion_3/img_trouble-01-2be194e543104744699907af7f188eac.png";